import { FC } from 'react';
import { IconProps } from '../types';

export const DollarCoinIcon: FC<IconProps> = ({ width = 16, height = 16, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.4026 12.6693H8.56927V11.8359C9.12483 11.7359 9.6026 11.5193 10.0026 11.1859C10.4026 10.8526 10.6026 10.3582 10.6026 9.7026C10.6026 9.23594 10.4693 8.80816 10.2026 8.41927C9.93594 8.03038 9.4026 7.69149 8.6026 7.4026C7.93594 7.18038 7.47483 6.98594 7.21927 6.81927C6.96371 6.6526 6.83594 6.42483 6.83594 6.13594C6.83594 5.84705 6.93871 5.61927 7.14427 5.4526C7.34983 5.28594 7.64705 5.2026 8.03594 5.2026C8.39149 5.2026 8.66927 5.28872 8.86927 5.46094C9.06927 5.63316 9.21371 5.84705 9.3026 6.1026L10.3693 5.66927C10.247 5.28038 10.022 4.94149 9.69427 4.6526C9.36649 4.36372 9.0026 4.2026 8.6026 4.16927V3.33594H7.43594V4.16927C6.88038 4.29149 6.44705 4.53594 6.13594 4.9026C5.82483 5.26927 5.66927 5.68038 5.66927 6.13594C5.66927 6.65816 5.82205 7.08038 6.1276 7.4026C6.43316 7.72483 6.91371 8.0026 7.56927 8.23594C8.26927 8.49149 8.75538 8.71927 9.0276 8.91927C9.29983 9.11927 9.43594 9.38038 9.43594 9.7026C9.43594 10.0693 9.30538 10.3387 9.04427 10.5109C8.78316 10.6832 8.46927 10.7693 8.1026 10.7693C7.73594 10.7693 7.41094 10.6554 7.1276 10.4276C6.84427 10.1998 6.63594 9.85816 6.5026 9.4026L5.4026 9.83594C5.55816 10.3693 5.79983 10.7998 6.1276 11.1276C6.45538 11.4554 6.88038 11.6804 7.4026 11.8026V12.6693ZM8.0026 14.6693C7.08038 14.6693 6.21372 14.4943 5.4026 14.1443C4.59149 13.7943 3.88594 13.3193 3.28594 12.7193C2.68594 12.1193 2.21094 11.4137 1.86094 10.6026C1.51094 9.79149 1.33594 8.92483 1.33594 8.0026C1.33594 7.08038 1.51094 6.21372 1.86094 5.4026C2.21094 4.59149 2.68594 3.88594 3.28594 3.28594C3.88594 2.68594 4.59149 2.21094 5.4026 1.86094C6.21372 1.51094 7.08038 1.33594 8.0026 1.33594C8.92483 1.33594 9.79149 1.51094 10.6026 1.86094C11.4137 2.21094 12.1193 2.68594 12.7193 3.28594C13.3193 3.88594 13.7943 4.59149 14.1443 5.4026C14.4943 6.21372 14.6693 7.08038 14.6693 8.0026C14.6693 8.92483 14.4943 9.79149 14.1443 10.6026C13.7943 11.4137 13.3193 12.1193 12.7193 12.7193C12.1193 13.3193 11.4137 13.7943 10.6026 14.1443C9.79149 14.4943 8.92483 14.6693 8.0026 14.6693Z"
        fill="url(#paint0_linear_3914_15841)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3914_15841"
          x1={1.33594}
          y1={1.33594}
          x2={1.33594}
          y2={14.6693}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.05} stopColor="#FBD98B" />
          <stop offset={0.95} stopColor="#EBB956" />
        </linearGradient>
      </defs>
    </svg>
  );
};
